// // config/clientDomains.js
// export const CLIENT_DOMAINS = {
//   "https://komz.dunetech.co.uk": "iacsa",
//   "https://members.iacsa.org.uk": "iacsa",
//   // Add more client domains here as needed
//   // 'https://client2.example.com': 'client2org',
//   // 'https://client3.example.com': 'client3org',
// };

// export const getClientOrgByDomain = (domain) => {
//   return CLIENT_DOMAINS[domain] || null;
// };

// export const isClientDomain = (domain) => {
//   return Object.keys(CLIENT_DOMAINS).includes(domain);
// };
// export const CLIENT_DOMAIN_CONFIG = {
//   "https://komz.dunetech.co.uk": "iacsa",
//   "https://members.iacsa.org.uk": "iacsa",
// };

// export const getClientOrgName = () => {
//   const currentDomain = window.location.origin;
//   return CLIENT_DOMAIN_CONFIG[currentDomain] || null;
// };

export const DOMAIN_CONFIG = {
  // Default domains
  DEFAULT_DEV: "https://komz.tech",
  DEFAULT_PROD: "https://komzhub.com",

  // Client-specific domains
  CLIENT_DOMAINS: {
    "https://komz.dunetech.co.uk": {
      orgName: "iacsa",
      environment: "dev",
    },
    "https://members.iacsa.org.uk": {
      orgName: "iacsa",
      environment: "prod",
    },
    // "http://localhost:3000": {
    //   orgName: "dune",
    //   environment: "dev",
    // },
  },
};

export const getCurrentDomainConfig = () => {
  const currentDomain = window.location.origin;
  return DOMAIN_CONFIG.CLIENT_DOMAINS[currentDomain] || null;
};

export const isClientDomain = () => {
  const currentDomain = window.location.origin;
  return Object.keys(DOMAIN_CONFIG.CLIENT_DOMAINS).includes(currentDomain);
};
